//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import nextStep from '@/components/nextStep/nextStep.vue';
import { getStorage } from "@/utils/localhost";
export default {
  components: {
    nextStep: nextStep
  },
  created: function created() {},
  watch: {//监听验证码 验证码只能写入6位
  },
  data: function data() {
    return {
      // passwordflag:true,
      errorList: {},
      count: "获取验证码",
      conFlag: '',
      //
      // 修改密码的表单验证
      // 修改手机号的表单验证
      ruleForm: {
        // password: '',
        phone: '',
        checkCode: '',
        curPhone: ''
      },
      rules: {
        phone: [{
          max: 11,
          message: '请输入正确的手机号'
        }, {
          required: true,
          validator: this.publicMethed.regularTest('phoneReg'),
          trigger: 'blur'
        }],
        checkCode: [{
          max: 6,
          message: '验证码长度不正确'
        }, {
          required: true,
          validator: this.publicMethed.regularTest('SMSCode'),
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.ruleForm.curPhone = this.userInfo.userPhone;
    this.$eventBus.$on("setSure", this.sureBtn);
  },
  destroyed: function destroyed() {
    this.$eventBus.$off('setSure');
  },
  methods: {
    phoneChange: function phoneChange(value) {
      if (value.length == 11) {
        if (this.count == "获取验证码") {
          this.conFlag = false;
        }
      } else {
        this.conFlag = true;
      }

      this.errorList = {
        phone: ''
      };
    },
    //获取验证码
    getCode: function getCode() {
      var _this = this;

      var a = /^1[3|4|5|6|7|8|9]\d{9}$/;

      if (!a.test(this.ruleForm.phone)) {
        this.errorList = {
          phone: '请输入正确的手机号'
        };
        return;
      }

      if (this.ruleForm.phone == this.ruleForm.curPhone) {
        this.errorList = {
          phone: '不可修改为当前手机号!'
        };
        return;
      }

      if (this.ruleForm.phone == '') {
        this.errorList = {
          phone: '请输入手机号'
        };
        return;
      }

      if (this.count != '获取验证码') {
        this.$message.error('请稍后再试');
        this.conFlag = true;
        return;
      }

      var TIME_COUNT = 60;

      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = true;
        this.timer = setInterval(function () {
          if (_this.count > 0 && _this.count <= TIME_COUNT) {
            _this.count--;
            _this.conFlag = true;
          } else {
            _this.conFlag = false;
            _this.show = false;
            clearInterval(_this.timer);
            _this.timer = null;
            _this.count = '获取验证码';
          }
        }, 1000);
      }

      this.requestAPI.login.getCode({
        mobile: this.ruleForm.curPhone,
        bizType: 'SMS30003'
      }).then(function (res) {}).catch(function () {
        _this.conFlag = false;
        _this.show = false;
        clearInterval(_this.timer);
        _this.timer = null;
        _this.count = '获取验证码';
      });
    },
    sureBtn: function sureBtn() {
      var _this2 = this;

      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          _this2.requestAPI.login.checkMsgCode({
            mobile: _this2.ruleForm.curPhone,
            verifyCode: _this2.ruleForm.checkCode,
            bizType: 'SMS30003'
          }).then(function (res) {
            _this2.requestAPI.PersonalSettings.ModifyPhone({
              userName: _this2.userInfo.userName,
              // userPwd: this.publicMethed.md5(this.publicMethed.md5(this.ruleForm.password)).toUpperCase(),
              userPhone: _this2.ruleForm.phone
            }).then(function (res) {
              var tip = '';

              if (res.errorCode == '0000') {
                tip = '修改成功!';

                var data = _this2.publicMethed.deepCopy(_this2.userInfo);

                data['userPhone'] = _this2.ruleForm.phone;

                _this2.$store.commit("onchangeUserInfo", data);

                _this2.$refs["ruleForm"].resetFields(); //移除校验结果并重置字段值


                _this2.ruleForm.curPhone = _this2.userInfo.userPhone;
              } else {
                tip = '操作失败!';
              }

              _this2.$confirm(tip, "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                showClose: false,
                showCancelButton: false,
                type: "warning"
              }).then(function () {}).catch(function () {});
            });
          });
        }
      });
    },
    // 提交表单
    submitForm: function submitForm(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.$message({
            message: '修改手机号成功',
            type: 'success'
          });
        } else {
          _this3.$message.error('验证码错误，请核对后重新输入');

          return false;
        }
      });
    },
    //返回上一个页面
    cancelFun: function cancelFun() {
      this.$router.go(-1);
    }
  }
};